export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const CAT_URL = process.env.REACT_APP_CAT_URL;

export const API_ROOT = process.env.REACT_APP_API_ROOT;
export const CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID;

//Fair warning, could not get value from process.env to work
export const ADMINS = (process.env.REACT_APP_ADMINS || 'webteam@pon.com').split(',');